import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { triangle } from 'polished';

const triangleProps = {
  pointingDirection: 'bottom',
  width: '12px',
  height: '6px',
};

const HIGHLIGHT_COLOR = '#990a00';

const markerHighlightStyles = ({ highlight }) => (highlight ? `background-color: ${HIGHLIGHT_COLOR}; color: white;` : '');
const triangleHighlightStyles = ({ highlight }) => (highlight ? `border-top-color: ${HIGHLIGHT_COLOR};` : '');

export const Marker = styled.button`
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -100%) translateY(-${triangleProps.height});
  background: white;
  border: none;
  border-radius: 3px;
  color: ${themeGet('colors.red')};
  padding: 5px 10px;
  font-size: ${themeGet('fontSizes.base')};
  font-weight: ${themeGet('fontWeights.bold')};
  font-family: ${themeGet('fontFamily')};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
  line-height: 0;
  z-index: ${(props) => (props.highlight ? '1' : 'auto')};

  &:hover {
    border: none;
  }
  &:focus {
    outline: 0;
  }

  ${markerHighlightStyles}
`;

export const RedTriangle = styled.div`
  ${(props) => triangle({ ...triangleProps, foregroundColor: themeGet('colors.white')(props) })}
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translate(-50%, -1px);

  ${triangleHighlightStyles}
`;
